const progressBarContainer: React.CSSProperties = {
  width: '100%',
  backgroundColor: '#e0e0e0' /* Couleur de fond */,
  borderRadius: '25px' /* Coins arrondis */,
  overflow: 'hidden',
  position: 'relative',
};

const progressBar: React.CSSProperties = {
  height: '20px' /* Hauteur de la barre */,
  borderRadius: '25px 25px 25px 25px' /* Coins arrondis à gauche */,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'width 0.3s ease' /* Animation de la largeur */,
};

const progressText: React.CSSProperties = {
  color: 'white' /* Couleur du texte */,
  fontWeight: 'bold',
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%,0)',
};

const style = {
  progressBarContainer,
  progressBar,
  progressText,
};

export default style;
